var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhatsnewBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1001,
    height: 91,
    viewBox: "0 0 1001 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1001,
    height: 90,
    transform: "translate(0 0.5)",
    fill: "#474F56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 30.5,
    cy: 20.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 77.5,
    cy: 20.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 124.5,
    cy: 20.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 171.5,
    cy: 20.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 218.5,
    cy: 20.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 265.5,
    cy: 20.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 312.5,
    cy: 20.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 359.5,
    cy: 20.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 406.5,
    cy: 20.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 453.5,
    cy: 20.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 500.5,
    cy: 20.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 547.5,
    cy: 20.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 594.5,
    cy: 20.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 641.5,
    cy: 20.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 688.5,
    cy: 20.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 735.5,
    cy: 20.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 782.5,
    cy: 20.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 829.5,
    cy: 20.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 876.5,
    cy: 20.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 923.5,
    cy: 20.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 970.5,
    cy: 20.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 30.5,
    cy: 70.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 77.5,
    cy: 70.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 124.5,
    cy: 70.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 171.5,
    cy: 70.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 218.5,
    cy: 70.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 265.5,
    cy: 70.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 312.5,
    cy: 70.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 359.5,
    cy: 70.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 406.5,
    cy: 70.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 453.5,
    cy: 70.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 500.5,
    cy: 70.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 547.5,
    cy: 70.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 594.5,
    cy: 70.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 641.5,
    cy: 70.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 688.5,
    cy: 70.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 735.5,
    cy: 70.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 782.5,
    cy: 70.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 829.5,
    cy: 70.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 876.5,
    cy: 70.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 923.5,
    cy: 70.5,
    r: 12,
    fill: "#D9D9D9"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 970.5,
    cy: 70.5,
    r: 12,
    fill: "#D9D9D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsnewBg);
export default __webpack_public_path__ + "static/media/whatsnew-bg.b88311b4fa2f2d407d99939d2ee61562.svg";
export { ForwardRef as ReactComponent };